export const ButtonBase = {
	name: 'ButtonBase',
	functional: true,
	props: {
		loading: Boolean,
		type: {
			type: String,
			default: 'button',
		},
		href: String,
	},
	render(h, { props, data, slots }) {
		const tag = props.href ? 'a' : 'button'

		return (
			<tag
				class={{
					'is-loading': props.loading,
				}}
				{ ...{
					...data,
					attrs: {
						...data.attrs,
						href: props.href ?? null,
						type: props.href ? null : props.type,
					},
				} }
			>
				{ slots().default }
			</tag>
		)
	}
}
